import Headline from '@allesauto/core/headline';
import TextLink from '@allesauto/core/textLink';
import {
  Colors,
  FieldTypeHTML,
  FieldTypeLink,
  theme,
} from '@allesauto/utils/consts';
import { createMarkup, getUrlFromStoryblokLink } from '@allesauto/utils/funcs';
import { renderRichText } from '@storyblok/react';
import clsx from 'clsx';

export interface TextsliderTileProps {
  headline: string;
  headlineTag: 2 | 3 | 4;
  headlineFontSize: 'title' | 'headline2' | 'headline3' | 'headline4';
  headlineColor: Colors;
  text?: FieldTypeHTML | string;
  link?: FieldTypeLink;
  linkText?: string;
  linkColor: Colors;
  _uid: string;
  component: string;
}

const cssClasses = {
  container: 'bg-white sm:p-[30px] lg:p-[95px] w-full',
  text: 'mt-10px',
};

const TextsliderTile = (props: TextsliderTileProps) => {
  const {
    headline,
    headlineColor,
    headlineTag,
    headlineFontSize,
    text,
    link,
    linkColor = Colors.PURPLE,
    linkText,
  } = props;

  const renderLink = link && linkText;

  return (
    <div className={cssClasses.container}>
      <Headline
        headlineTag={headlineTag}
        headlineText={headline}
        headlineColor={theme[headlineColor].text}
        headlineClassName={`text-${headlineFontSize}`}
      />
      <div
        className={cssClasses.text}
        dangerouslySetInnerHTML={createMarkup(
          (text as FieldTypeHTML)?.type
            ? renderRichText(text)
            : (text as string)
        )}
      />
      {renderLink && (
        <TextLink
          textColor={theme[linkColor].text}
          customClassName={clsx(cssClasses.text, theme[linkColor].fill)}
          fillColor={theme[linkColor].text}
          text={linkText}
          href={getUrlFromStoryblokLink(link)}
        />
      )}
    </div>
  );
};

export default TextsliderTile;
